<template>
	<div class="login">
		<LoginHead>修改密码</LoginHead>
            <RegFrame>
			<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="手机号码：" class="login_d2_d2_el1" prop="inp1">
					<el-input placeholder="请输入手机号码" v-model="ruleForm.inp1">
					</el-input>
				</el-form-item>
				<el-form-item label="验证码：" class="login_d2_d2_el1" prop="inp2">
					<el-input placeholder="请输入验证码" v-model="ruleForm.inp2">
						<el-button slot="append">获取验证码</el-button>
					</el-input>
				</el-form-item>
				<el-form-item label="新 密 码：" class="login_d2_d2_el1" prop="inp3">
					<el-input placeholder="请输入新密码" type="password" v-model="ruleForm.inp3">
					</el-input>
				</el-form-item>
				<el-form-item label="确认密码：" class="login_d2_d2_el1" prop="inp4">
					<el-input placeholder="请再次输入新密码" type="password" v-model="ruleForm.inp4">
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button class="login_d2_d2_el1_but" type="success" @click="submitForm('ruleForm')">修改</el-button>
				</el-form-item>
			</el-form>
        </RegFrame>
        <div :style="{ height:'100px' }"></div>
		<Foot />
	</div>
</template>

<style>
	.login .el-form-item__content {
		line-height: 16px !important;
	}
</style>

<script>
    import Foot from "@/components/Foot"
    import LoginHead from "@/components/LoginHead"
    import RegFrame from "@/components/RegFrame"
	export default {
        components:{
            Foot,
            LoginHead,
            RegFrame
        },
		data() {
			var inp1Pass = (rule, value, callback) => {
				if (value === '') {
					return callback(new Error('手机号不能为空'));
				} else if (!(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value))) {
					return callback(new Error('手机号格式有误'));
				} else {
					callback();
				}
			};
			var inp2Pass = (rule, value, callback) => {
				if (value === '') {
					return callback(new Error('验证码不能为空'));
				} else {
					callback();
				}
			};
			var inp3Pass = (rule, value, callback) => {
				if (value === '') {
					return callback(new Error('新密码不能为空'));
				} else {
					callback();
				}
			};
			var inp4Pass = (rule, value, callback) => {
				if (value === '') {
					return callback(new Error('确认密码不能为空'));
				} else if (value != this.ruleForm.inp3) {
					return callback(new Error('两次输入的密码不一致'));
				} else {
					callback();
				}
			};
			
			return {
				ruleForm: {
					inp1: '',
					inp2: '',
					inp3: '',
					inp4: ''
				},
				rules: {
					inp1: [{
						validator: inp1Pass,
						trigger: 'blur'
					}],
					inp2: [{
						validator: inp2Pass,
						trigger: 'blur'
					}],
					inp3: [{
						validator: inp3Pass,
						trigger: 'blur'
					}],
					inp4: [{
						validator: inp4Pass,
						trigger: 'blur'
					}],
				}
			}
		},
        

		computed: {

		},
		watch: {

		},
		created: function() {

		},
		mounted: function() {

		},
		methods: {
			toLogin(){
				this.$router.push("/login")
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
		}
	}
</script>


<style scoped >
    .reg_d2_pad{
	width: 80%;
	margin: 0 auto;
}

.regd2pad_d1{
	width: 100%;
	height: 60px;
	box-sizing: border-box;
	border-bottom:1px solid #cccccc;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-end;
}

.regd2pad_d1_sp1{
	height: 60px;
	line-height: 60px;
	box-sizing: border-box;
	border-bottom:2px solid #0aac58;
	margin-left: 10px;
	color: #0aac58;
	font-size: 24px;
	position: relative;
	top: 1px;
}

.regd2pad_d1_d2{
	height: 40px;
	line-height: 40px;
	font-size: 14px;
}

.regd2pad_d1_d2 a{
	color: #409EFF;
}

.login_d2_d2_el1{
	width: 90%;
}

.demo-ruleForm{
	margin-top: 50px;
}

</style>

<style lang="scss" scoped src="./desktop.scss" ></style>